<template>
  <v-row
    v-if="freeTimes.length > 0"
    no-gutters
    class="scheduled-classes-row"
    id="scheduled-classes-row"
    justify="center"
  >
    <v-row style="width: 100%;">
      <v-col class="scheduled-classes-row-title-lines"></v-col>
      <div class="scheduled-classes-row-title">Aulas marcadas</div>
      <v-col class="scheduled-classes-row-title-lines"></v-col>
    </v-row>

    <div
      v-for="scheduledClass in filteredScheduledClasses"
      :key="scheduledClass.id"
      class="regular-shadow scheduled-class-card"
      @click="verifyClassroomStatus( scheduledClass )"
    >

      <div class="scheduled-class-card-date text-truncate" v-if="!scheduledClass.cancel">
        <span v-bind:class="{ today: isToday(scheduledClass) }">
          {{
            new Date(scheduledClass.date).toLocaleDateString("pt-BR", { weekday: "short", timeZone: "UTC"}).slice(0, -1)
          }}</span
        >
        <span class="time"
          ><br />{{
            scheduledClass.start_at
          }}:00</span
        >
      </div>
      <div class="scheduled-class-card-details text-truncate" v-if="!scheduledClass.cancel">
        {{
          new Date(scheduledClass.date).toLocaleString("pt-BR", {
            day: "numeric",
            month: "short",
            timeZone: "UTC"
          })
        }}
        <br />Prof. {{ findProfessor(scheduledClass.professor_id) }} <br /><b>{{
          classrooms(scheduledClass.classroom_id)
            ? classrooms(scheduledClass.classroom_id).name
            : "Em casa"
        }}</b>
      </div>



      <div class="scheduled-class-card-date-canceled text-truncate" v-if="scheduledClass.cancel">
        <span v-bind:class="{ canceled: isCanceled(scheduledClass) }">
          {{
            new Date(scheduledClass.date).toLocaleDateString("pt-BR", { weekday: "short", timeZone: "UTC"}).slice(0, -1)
          }}
        </span>

        <span class="time"
          ><br />{{
            scheduledClass.start_at
          }}:00</span
        >
      </div>
      <div class="scheduled-class-card-details text-truncate" v-if="scheduledClass.cancel">
        {{
          new Date(scheduledClass.date).toLocaleString("pt-BR", {
            day: "numeric",
            month: "short",
            timeZone: "UTC"
          })
        }}
        <br />Prof. {{ findProfessor(scheduledClass.professor_id) }} <br />
        <b>
          Cancelada
        </b>
      </div>

    </div>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import weekdayMapper from "@/models/weekdayMapper";
import StudentsRepository from "@/repositories/StudentsRepository";

export default {
  props: {
    classrooms: Function,
    scheduledClasses: Array
  },
  data() {
    return {
      freeTimes: [],
      weekdayMapper: weekdayMapper
    };
  },
  computed: {
    ...mapState(["professors"]),

    filteredScheduledClasses() {
      return this.scheduledClasses.filter(
        ({ date }) =>
          new Date(date).getTime() > new Date().getTime() - 86400000
      );
    }
  },
  async mounted() {
    const studentsResponse = await StudentsRepository.listScheduledClasses();
    this.freeTimes = studentsResponse.data.free_times;
  },

  watch: {
    scheduledClasses: {
      immediate: true,
      async handler() {
        const studentsResponse = await StudentsRepository.listScheduledClasses();
        this.freeTimes = studentsResponse.data.free_times;
      }
    }
  },
  methods: {
    findFreeTime(freeTimeId) {
      return this.freeTimes.find(freeTime => freeTime.id === freeTimeId) || {};
    },
    findProfessor(professorId) {
      const professor = this.professors.find(
        professor => professor && professor.user_id === professorId
      );
      return professor ? professor.name : "";
    },

    isToday(scheduledClass) {
      return (
        new Date(scheduledClass.date).toDateString() ===
        new Date().toDateString()
      );
    },

    isCanceled( scheduledClass ) {
      return true
    },

    verifyClassroomStatus( scheduledClass ) {
      if ( !scheduledClass.cancel || scheduledClass.cancel == null ) {
        this.$emit('view-class', scheduledClass)
      }
    }

  }
};
</script>

<style scoped>
.scheduled-classes-row {
  margin-top: 60px;
  padding: 0 46px 72px;
  max-width: 540px;
  margin-left: auto;
  margin-right: auto;
}
.scheduled-classes-row-title {
  color: #44ff99;
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 6px;
  font-weight: 400;
  margin-bottom: 12px;
}
.scheduled-classes-row-title-lines {
  border-top: 1px solid #ffffff;
  height: 0px;
  margin: 6px 12px 0;
}
.scheduled-class-card {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 90px;
  max-width: 400px;
  background-color: #ffffff;
  border: 2px solid #44ff99;
  width: 100%;
  border-radius: 999px;
  margin-bottom: 9px;
  padding: 6px 0;
  transition: 0.1s;
}
.scheduled-class-card:hover {
  background-color: #44ff99;
}
.scheduled-class-card:active {
  background-color: #f9f9f9;
  transform: scale(0.97);
  transition: 0.1s ease-out;
}

.scheduled-class-card.canceled {
  border: 2px solid rgb(101, 97, 102) !important;
}


.scheduled-class-card-date-canceled {
  color: rgba(101, 97, 102, 0.7) !important;
  width: 35% !important;
  min-width: 95px !important;
  text-align: right !important;
  font-size: 32px !important;
  font-weight: 900 !important;
  line-height: 0.85 !important;
  text-transform: uppercase !important;
}

.scheduled-class-card.canceled div.scheduled-class-card-date span,
.scheduled-class-card.canceled div.scheduled-class-card-date span.today {
  background-color: rgba(255,255,255,0) !important;
}



.scheduled-class-card-date {
  width: 35%;
  min-width: 95px;
  text-align: right;
  font-size: 32px;
  font-weight: 900;
  color: #1a004c;
  line-height: 0.85;
  text-transform: uppercase;
}
.scheduled-class-card-date span.today {
  background-color: #44ff99;
}

.scheduled-class-card-date span.time,
.scheduled-class-card-date-canceled span.time {
  font-size: 24px;
}
.scheduled-class-card-details {
  color: #877e91;
  line-height: 1.3;
  margin-left: 18px;
  padding: 0 9px 0 18px;
  border-left: 1px solid #877e91;
  font-size: 13px;
}
</style>
